// eslint-disable-next-line
import _ from 'lodash';
import {TGEN_UNAME, TGET_USERNAME, TGET_USERINFO, TSOCIAL_LOGIN,
  TSOCIAL_NOT_LOGGED_IN, TRESET_ERR, TCREATE_USER,
  TLOGGING_OUT_USER,  TLOGGED_OUT_USER, TNOT_LOGGED_OUT_USER,
  TSOCIAL_LOGGED_IN, TUSER_CREATED, TUSER_NOT_CREATED,
  TFBASE_USER_LOGIN, TFBASE_USER_NOT_LOGGEDIN, TFBASE_CREATE_USER,
  TFBASE_USER_NOT_CREATED, TUPDATING_USER, TUSER_UPDATED, TUSER_NOT_UPDATED,
  TGET_MATCH_SCORE, TGOT_MATCH_SCORE, TMATCH_SCORE_FAIL,
  TFOLLOWING_USER, TUSER_FOLLOWED, TUSER_NOT_FOLLOWED,
  TGETTING_FOLLOWING, TGOT_FOLLOWING, TNOT_GOT_FOLLOWING,
} from '../actions/types';

const INIT_STATE = {
  username: null,
  name: null,
  loading: false,
  error: '',
  updated: '',
  generated_uname: '',
  userInfo: {},
  mscore: {},
  mscore_loading: false,
  following: {
    users: null,
    last_action: null,
    loading_action: false,
    loading_get: false,
  },
};

export default function(state=INIT_STATE, action) {
  switch(action.type) {
  // case DELETE_POST:
  //   // remove id from the state
  //   return _.omit(state, action.payload);

  case TLOGGED_OUT_USER:
    console.log('yo...im out!');
    // eslint-disable-next-line
    return {...state, ...INIT_STATE}

  case TSOCIAL_LOGGED_IN:
    // eslint-disable-next-line
    return {...state, loading: false}

  case TSOCIAL_LOGIN:
  case TCREATE_USER:
  case TLOGGING_OUT_USER:
  case TFBASE_USER_LOGIN:
  case TFBASE_CREATE_USER:
    // eslint-disable-next-line
    return {...state, loading: true};

  case TUSER_CREATED:
  case TGET_USERNAME:
    // eslint-disable-next-line
    return {...state, loading: false, username: action.username, name: action.name};

  case TUSER_NOT_CREATED:
  case TUSER_NOT_UPDATED:
  case TNOT_LOGGED_OUT_USER:
  case TSOCIAL_NOT_LOGGED_IN:
  case TFBASE_USER_NOT_CREATED:
  case TFBASE_USER_NOT_LOGGEDIN:
    return {...state, loading: false, error: action.errMsg}

  case TUSER_NOT_FOLLOWED:
    const fdata_unf = {last_action: null, loading_action: false}
    return {...state, error: action.errMsg, following: {...state.following, ...fdata_unf}}

  case TNOT_GOT_FOLLOWING:
    const fdata_ngf = {users: null, loading_get: false}
    return {...state, error: action.errMsg, following: {...state.following, ...fdata_ngf}}

  case TMATCH_SCORE_FAIL:
    return {...state, mscore_loading: false, error: action.errMsg}

  case TUSER_UPDATED:
    const wasUNameUpdated = !action.updated.isEmpty && 'user' in action.updated &&
      'username' in action.updated.user;

    // NOTE QUESTION need to check and update fullname also?? (now that we are saving that to the profile also)
    if (wasUNameUpdated) {
      const {username} = action.updated.user;
      return {...state, updated: action.updated, username, loading: false}
    }

    return {...state, updated: action.updated, loading: false};

  case TUPDATING_USER:
    return {...state, updated: '', loading: true};

  case TFOLLOWING_USER:
    return {...state, following: {...state.following, loading_action: true}}

  case TUSER_FOLLOWED:
    const fdata_uf = {last_action: action.confirm_data, loading_action: false}
    return {...state, following: {...state.following, ...fdata_uf}}

  case TGETTING_FOLLOWING:
    return {...state, following: {...state.following, loading_get: true}}

  case TGOT_FOLLOWING:
    const fdata_gf = {users: action.confirm_data, loading_get: false}
    return {...state, following: {...state.following, ...fdata_gf}}

  case TGEN_UNAME:
    return {...state, generated_uname: action.payload.data.results[0].login.username};

  case TGET_USERINFO:
    return {...state, userInfo: action.payload.data};

  case TGET_MATCH_SCORE:
    return {...state, mscore_loading: true, mscore: {}};

  case TGOT_MATCH_SCORE:
    return {...state, mscore: action.payload.data, mscore_loading: false};

  // case FETCH_POSTS:
  //   // built in lodash function, which takes a list and turns it into a hash/object
  //   return _.mapKeys(action.payload.data, 'id');

  case TRESET_ERR:
    return {...state, error: ''};

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_user_profile.js